module.exports = __webpack_public_path__ + "static/Light-Blue-b58cbfbb6b0148a2550ef12fa2abf466.png";